import React from "react";
import { Link } from "react-router-dom";
import "../App.css";

const Details = ({ goBack, goNext }) => {
  return (
    <div>
      <ul className="styled-list">
        <li>
          <Link to="/register/client/age">
            Yes, I am 18 years or over <span className="arrow">{">"}</span>
          </Link>
        </li>
        <li>
          <a href="#">
            No, my guardian will be the account holder{" "}
            <span className="arrow">{">"}</span>
          </a>
        </li>
      </ul>

      {/* Your form inputs here */}
      <button onClick={goBack}>Back</button>
      <button onClick={goNext}>Next</button>
    </div>
  );
};

export default Details;
